import { render, staticRenderFns } from "./AdManSpaceNew.vue?vue&type=template&id=47cc178d&scoped=true"
import script from "./AdManSpaceNew.vue?vue&type=script&lang=js"
export * from "./AdManSpaceNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cc178d",
  null
  
)

export default component.exports